// This file is generated by scripts/generate-sprite-sheet-manifest.mjs.
// Do not edit by hand.

export const GENERATED_UNIT_COLOR_IDS = [
  "purple",
  "blue",
  "green",
  "orange"
];
